import type { MarketTopic } from '../../types/market'
import { MARKET_BASE_PATH } from './config'
import { startTopics } from './topicsStart'
import { tradeTopics } from './topicsTrade'
import { moneyTopics } from './topicsMoney'
import { helpTopics } from './topicsHelp'

/** 15 temas de usuario + 3 de consulta, en el orden del manual. Sin contenido administrativo. */
export const marketTopics: MarketTopic[] = [...startTopics, ...tradeTopics, ...moneyTopics, ...helpTopics]

export const topicByKey = (key: string) => marketTopics.find((t) => t.key === key)
export const topicBySlug = (slug: string | undefined) => marketTopics.find((t) => t.slug === slug)
export const topicPath = (t: MarketTopic, hash?: string) => `${MARKET_BASE_PATH}/${t.slug}${hash ? `#${hash}` : ''}`

/** Accesos de la portada. */
export const quickAccess: { label: string; key: string; text: string }[] = [
  { label: 'Empezar', key: 'user-start', text: 'Espacios del mercado y tu primera operación.' },
  { label: 'Comprar', key: 'user-catalog', text: 'Catálogo, carrito y confirmación.' },
  { label: 'Vender', key: 'user-publish', text: 'Publica desde la mochila y revisa el neto.' },
  { label: 'Donar', key: 'user-recharge', text: 'Genera la orden de donación y realízala en USDT.' },
  { label: 'Retirar USDT', key: 'user-withdraw', text: 'Convierte créditos en USDT a tu Binance ID.' },
  { label: 'Recibir o recuperar mis ítems', key: 'user-delivery', text: 'Mis ítems, resguardo y Gremory → Cuenta.' },
  { label: 'Resolver un problema', key: 'user-faq', text: 'Preguntas frecuentes y datos para soporte.' },
]

/** Recorrido completo de compra documentado, para la portada. */
export const buyJourney = [
  'Inicia sesión',
  'Revisa la publicación',
  'Agrega al carrito',
  'Comprueba cantidades, total y saldo',
  'Desconecta la cuenta completa',
  'Elige personaje si hay buffs',
  'Revisar compra',
  'Comprueba destino y saldo restante',
  'Acepta y pulsa Pagar',
  'Consulta Mis compras',
  'Retira en Gremory → Cuenta si corresponde',
]
